import { useEffect, useRef } from 'react'

export default ({ onClickAway, ...props }) => {
  const rootRef = useRef(null)

  useEffect(() => {
    document.addEventListener('click', onDocumentClick)

    function onDocumentClick(e) {
      if (!rootRef.current) {
        return
      }

      if (
        document.documentElement &&
        document.documentElement.contains(e.target) &&
        !rootRef.current.contains(e.target)
      ) {
        onClickAway?.(e)
      }
    }

    return () => {
      document.removeEventListener('click', onDocumentClick)
    }
  }, [onClickAway])

  return <div ref={rootRef} {...props} />
}
